<template>
  <validation-observer ref="bankRequestObserver" novalidate tag="form">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fa fa-credit-card-front color-orange" />
        Reclamación de Solicitud al banco
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.requestDate"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de reclamación."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.comment"
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="submit"
        />
      </div>
    </div>
  </validation-observer>
</template>
<script>
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@/mixins/alert.mixin';
import { putCardBankRequest } from '@/modules/shared/cardHandling.api';
export default {
  name: 'BankRequest',
  components: {
    CustomTextArea,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  data: () => ({
    model: {
      requestDate: null,
      comment: null,
    },
  }),
  methods: {
    async submit() {
      const isValid = await this.$refs.bankRequestObserver.validate();
      if (isValid) {
        this.model.becaCardId = this.id;
        await putCardBankRequest(this.model)
          .then(() => {
            this.ShowToast(
              'Confirmación',
              'La reclamación ha sido realizada exitosamente.',
              'success'
            );
            this.$emit('on-saved');
          })
          .catch((err) => {
            if (err && err.response && err.response.data) {
              this.ShowToast('Error', err.response.data.message, 'error');
            } else {
              this.ShowToast('Error', err.message, 'error');
            }
          });
      }
    },
  },
};
</script>
<style scoped lang="scss"></style>
